/**
 * Busca o valor de copeira_override do localStorage
 * Retorna o valor como string (ID do Salesforce) ou null se não existir
 * 
 * @returns {string | null} Valor string do copeira_override ou null
 */
export function getCopeiraOverride(): string | null {
  const value = localStorage.getItem('copeira_override');
  // Retornar null se não existir ou se for string vazia
  return value && value.trim() !== '' ? value : null;
}

/**
 * Limpa o valor de copeira_override do localStorage
 */
export function clearCopeiraOverride(): void {
  localStorage.removeItem('copeira_override');
}

/**
 * Define o valor de copeira_override no localStorage
 * 
 * @param {string | null} value - Valor string (ID do Salesforce) ou null para limpar
 */
export function setCopeiraOverride(value: string | null): void {
  if (value === null || value.trim() === '') {
    clearCopeiraOverride();
  } else {
    localStorage.setItem('copeira_override', String(value));
  }
}
